import AxiosInstance from "../config/AxiosInstance";

export const getListAsset = async (page: any, limit: any, search: any, companyId: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/asset/list', {
            params: {
                page: page,
                limit: limit,
                search: search,
                companyId: companyId,
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};
export const getDetailAsset = async (id: any, companyId: any, page: any, limit: any, year: any) => {
    try {
        const { data } = await AxiosInstance.get('/api/finex/asset/getAssetById', {
            params: {
                id: id,
                companyId: companyId,
                page: page,
                limit: limit,
                year: year
            }
        });
        return { data };
    } catch (error) {
        throw error;
    }
};